
const rootlCookieName = "rootlCookie";

export { rootlCookieName };